export { default } from './WarningIndicator';
